import EditIcon from "@mui/icons-material/Edit";
import { Checkbox, FormControlLabel } from "@mui/material";
import { includes } from "lodash";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import Installments from "../deal/Installments";
import PropertyUpdateModalContainer from "../property/PropertyUpdateModalContainer";
import { consultingDealTypes } from "../types/consultingDealTypes";
import { propertyTypes } from "../types/propertyTypes";
import { buildAddress } from "../utils/operations";
import BrokerCommissions from "./BrokerCommissions";
import CommissionDistribution from "./CommissionDistribution";
import "./ConsultingDeal.css";

const ConsultingDeal = (props) => {
    const {
        autocompleteResults,
        brokerCommissions,
        disableInputs,
        errors,
        handleAddArrayElement, // (path)
        handleAddBrokerCommission,
        handleAddRunner,
        handleCheckboxClick,
        handleCreateOutsideSplitDraft,
        handleDeleteArrayElement, // (path, value)
        handleDeleteOutsideSplit,
        handleInput,
        handleReducerLevelInput,
        handleRemoveCommissionOrRunner,
        handleSaveOutsideSplit,
        handleSearchBroker,
        handleSearchCompany,
        handleSearchPerson,
        handleUpdateArrayElement, // (arrayPath, index, field, value)
        outsideSplitModal,
        outsideSplits,
        searchResults,
        setInitialPaymentMethod,
        toggleOutsideSplitModal,
        togglePropertySearchModal,
        updateBrokerPerson,
        updatedProperty,
        updateRunner,
        updateSplit,
        userProfile,
        voucher,
        handleBlurValidate
    } = props;

    if (voucher.paymentMethod === null) {
        setInitialPaymentMethod("CHECK");
    }
    const formDisabled = false;

    return (
        <div>
            <form>
                <div className="simPaper">
                    {/* Consulting Information */}

                    <div style={{ marginBottom: "8px" }}>
                        <div className="formTitleNoSpace"> Consulting Information </div>
                        <small className="entityIDText">Voucher ID: {voucher.voucherKey}</small>
                    </div>

                    <hr className="hrDivider" />

                    <div>
                        <div className="consultingDealFlexContainerUnresponsive">
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="consultingDealName"
                                    label="Consulting Deal Name"
                                    value={voucher?.deal?.consultingDealName}
                                    error={errors?.deal?.consultingDealName}
                                    onChange={(e) => handleInput("deal.consultingDealName", e.target.value)}
                                    placeholder="Enter consulting deal name"
                                    disabled={formDisabled}
                                    helperText="Required"
                                    errorText="Required"
                                    onBlurValidate={(id, value) => handleBlurValidate(null, id, value)}
                                />
                            </div>
                            <div className="flexGrowSingle">
                                <BSSelect
                                    id="consultingDealType"
                                    label="Type"
                                    value={voucher?.deal?.consultingDealType}
                                    error={errors?.deal?.consultingDealType}
                                    onChange={(e) => handleInput("deal.consultingDealType", e.target.value)}
                                    placeholder="Select type"
                                    helperText="Required"
                                    errorText="Required"
                                    options={consultingDealTypes}
                                    disabled={formDisabled}
                                    onBlurValidate={(id, value) => handleBlurValidate(null, id, value)}
                                />
                            </div>
                        </div>
                        <div className="consultingDealFlexContainerUnresponsive">
                            <div style={{ marginBottom: "22px", width: "100%" }}>
                                <BSSelect
                                    className="flexGrowSingle"
                                    id="propertyType"
                                    label="Property Type"
                                    value={voucher?.deal?.propertyType}
                                    error={errors.propertyType}
                                    onChange={(e) => handleInput("deal.propertyType", e.target.value)}
                                    placeholder="Select type"
                                    options={[
                                        {
                                            value: "",
                                            label: "Select",
                                            disabled: true,
                                        },
                                        ...propertyTypes,
                                    ]}
                                    disabled={formDisabled}
                                />
                            </div>
                            <div style={{ marginBottom: "22px", width: "100%" }}>
                                <BSInput
                                    className="flexGrowSingle"
                                    id="clientName"
                                    label="Client Name"
                                    value={voucher?.deal?.clientName}
                                    error={errors?.deal?.clientName}
                                    onChange={(e) => handleInput("deal.clientName", e.target.value)}
                                    placeholder="Enter client name"
                                    disabled={formDisabled}
                                    helperText="Required"
                                    errorText="Required"
                                    onBlurValidate={(id, value) => handleBlurValidate(null, id, value)}
                                />
                            </div>
                        </div>
                        {includes(["dataAdmin", "dataEntry"], userProfile.role) ? (
                            <div className="consultingDealFlexContainer">
                                <div className="flexGrow50" style={{ display: "flex", alignItems: "center" }}>
                                    <BSInput
                                        id="propertyAddress"
                                        label="Property Address"
                                        value={buildAddress(
                                            updatedProperty.primaryAddress ?? voucher?.deal?.property?.primaryAddress
                                        )}
                                        error={errors.propertyAddress}
                                        placeholder="Enter address"
                                        disabled={true}
                                    />
                                    <div
                                        className="updateProperty"
                                        style={{ paddingBottom: "12px", paddingLeft: "12px" }}
                                    >
                                        <EditIcon
                                            style={{
                                                width: "24px",
                                                height: "24px",
                                                fill: "#233a47",
                                            }}
                                            onClick={() => togglePropertySearchModal(true)}
                                        />
                                        <div>
                                            <PropertyUpdateModalContainer
                                                {...props}
                                                formType="consulting"
                                                consultingDealKey={voucher?.deal?.dealKey}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="consultingDealFlexContainer">
                                <div className="flexGrow50">
                                    <BSInput
                                        id="propertyAddress"
                                        label="Property Address"
                                        value={buildAddress(
                                            updatedProperty.primaryAddress ?? voucher?.deal?.property?.primaryAddress
                                        )}
                                        error={errors.propertyAddress}
                                        placeholder="Enter address"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    <CommissionDistribution {...props} formDisabled={false} />

                    <Installments
                        {...props}
                        installments={voucher?.deal?.installments ?? []}
                        handleAddArrayElement={(path) =>
                            handleAddArrayElement("deal." + path, {
                                installmentKey: null,
                                amount: null,
                                dueDate: null,
                                uniqueId: crypto.randomUUID(),
                            })
                        }
                        handleDeleteArrayElement={(path, index) => handleDeleteArrayElement("deal." + path, index)}
                        handleUpdateArrayElement={(arrayPath, index, field, value) =>
                            handleUpdateArrayElement("deal." + arrayPath, index, field, value)
                        }
                        errors={errors}
                        disableInputs={disableInputs}
                        onlyEditCurrentInstallment={false}
                        preventAddSubtract={(voucher?.deal?.installments ?? []).length > 0}
                        isConsultingDeal={true}
                    />

                    <div style={{ display: "flex", gap: "25px" }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={voucher?.deal?.kmExclusiveFlg}
                                    onChange={(e) => handleCheckboxClick("deal.kmExclusiveFlg", e)}
                                    value={voucher.kmExclusiveFlg}
                                    color="primary"
                                    disabled={formDisabled}
                                />
                            }
                            label="Is this listing KM Exclusive?"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={voucher?.deal?.propertyManagementPaymentFlg}
                                    onChange={(e) => handleCheckboxClick("deal.propertyManagementPaymentFlg", e)}
                                    value={voucher.propertyManagementPaymentFlg}
                                    color="primary"
                                    disabled={formDisabled}
                                />
                            }
                            label="Is this payment handled by Asset Services?"
                        />
                    </div>

                    <hr />

                    {/* Installment Commission Allocation and Totals */}

                    <BrokerCommissions
                        {...props}
                        voucher={voucher}
                        brokerCommissions={brokerCommissions}
                        outsideSplits={outsideSplits}
                        handleAddBrokerCommission={handleAddBrokerCommission}
                        handleCreateOutsideSplitDraft={handleCreateOutsideSplitDraft}
                        handleSaveOutsideSplit={handleSaveOutsideSplit}
                        handleDeleteOutsideSplit={handleDeleteOutsideSplit}
                        handleAddRunner={handleAddRunner}
                        handleRemoveCommissionOrRunner={handleRemoveCommissionOrRunner}
                        updateSplit={updateSplit}
                        updateRunner={updateRunner}
                        outsideSplitModal={outsideSplitModal}
                        toggleOutsideSplitModal={toggleOutsideSplitModal}
                        handleSearchPerson={handleSearchPerson}
                        handleSearchCompany={handleSearchCompany}
                        searchResults={searchResults}
                        updateBrokerPerson={updateBrokerPerson}
                        errors={errors}
                        formDisabled={formDisabled}
                        autocompleteResults={autocompleteResults}
                        handleSearchBroker={handleSearchBroker}
                        handleInput={(path, value) => handleInput(path, value)}
                        handleReducerLevelInput={handleReducerLevelInput}
                    />
                </div>
            </form>
        </div>
    );
};

export default ConsultingDeal;
